<template>
  <div class="gmap-container">
    <div class="lamp-search">
      <div :class="searchShow?'search-text search-show':'search-text'">
        <el-select
          class="search-select"
          v-model="selectedLamp"
          :placeholder="$t('gis.please_name')"
          filterable
          clearable
          @change="selectChange"
        >
          <el-option
            v-for="(item, index) in searchDeviceList"
            :key="index"
            :label="item.name"
            :value="{value: item.number, index: index}"
          >
          </el-option>
        </el-select>
      </div>
      <div class="search-btn" @click="searchShow=!searchShow"><i class="el-icon-search"></i></div>
    </div>
    <div class="googleMap" id="googleMap" style="height: 100%; width: 100%;"></div>

    <!-- 设备控制设置 -->
    <div
      v-if="lightSetItem.visible"
      class="box_control_bg"
      @click="closeSet"
    ></div>
    <div v-if="lightSetItem.visible" class="box_control w750">
      <div class="box_head">
        <span class="box_title">{{ lightSetItem.title }}-{{$t('device.light_control')}}</span>
        <div class="box_close" @click="closeSet">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="box_body">
        <light-set
          ref="lightSet"
          :setData="lightSetItem.lightSetData"
          @updated="getLampList()"
        ></light-set>
      </div>
    </div>
    
  </div>
</template>
<script>
import { Loader } from '@googlemaps/js-api-loader';
import lampsApi from "@/api/device/lamps";
import videoControl from "@/components/video/VideoControl";
import videoBox from '@/components/video/VideoBox.vue'
import lightSet from "@/components/device/lamps/lightControl"
import { ACCOUNT_MAP } from '@/config/index.js';
export default {
  name: "Amap",
  components: {
    videoBox,
    lightSet,
    videoControl
  },
  data() {
    return {
      selectedLamp: "",
      searchShow: 0,
      lampInfo: {
        name: "",
        lamp_id: "",
        stg_id: "",
        stg_name: "",
        light: "",
        ms: "",
        sb: [],
        camera_list: [],
      },
      pageInfo: {
        sortBy: 'lamp_id',
        descending: 'desc',
        filter: '',
        page: 1,
        pageSize: 10000
      },
      lampList: [],
      lightSetItem: {
        visible: false,
        title: "",
        lightSetData: {}
      },
      gMapObj: {
        zoom: 11,
        mapCenter: {
          lng: null,
          lat: null
        },
        //谷歌地图配置
        mapOptions: {
          //为了关闭默认控件集,设置地图的disableDefaultUI的属性为true
          disableDefaultUI: false,
          // 启用缩放和平移
          gestureHandling: 'greedy',
          panControl: true,
          zoomControl: true,
          scaleControl: true,
          // 街景
          streetViewControl: true
        }
      },
      googleApi: null,
      googleMap: null,
      markers: [],
      searchDeviceList: [],
      markerInstances: [], // 用于存储所有Marker实例
      infoWindowInstances: [], // 用于存储所有InfoWindow实例
      currentInfoWindow: null // 用于存储当前打开的InfoWindow实例
    }
  },
  created() {
    let mapData = ACCOUNT_MAP
    const mapDataStr = localStorage.getItem('mapData');
    if(mapDataStr){
      mapData = JSON.parse(mapDataStr)
    }
    this.gMapObj.mapCenter.lng = mapData.center[0]
    this.gMapObj.mapCenter.lat = mapData.center[1]

    this.$nextTick(async () => {
      await this.getLampList();
      this.intMap()
    })
  },
  methods: {
    async getLampList() {
      await lampsApi.lightList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          const resData = res.data.data.list;
          if(resData&&resData.length){
            this.lampList = resData;
          }else{
            this.lampList = [];
          }
        }
      });
    },
    async intMap() {
      const loader = new Loader({
        apiKey: 'AIzaSyD6LsyhR_jPcier48qiZXQFrFYGrunsaf4',
        version: 'weekly', //版本
        libraries: ['places'], //插件库places为基础库 drawing为绘制工具库
        language: 'en',
      })
      // console.log('mapCenter', this.gMapObj.mapCenter)
      const mapOptions = {
        center: this.gMapObj.mapCenter, //中心点
        zoom: this.gMapObj.zoom, //缩放级别
        ...this.gMapObj.mapOptions, //其他配置
      }
      await loader.load()
      .then((google) => {
        const map = new google.maps.Map(document.getElementById('googleMap'), mapOptions);
        this.googleMap = map;
        this.googleApi = google;

        // 添加多个标记点并设置边界
        const bounds = new google.maps.LatLngBounds();
        this.lampList.forEach(async markerOptions => {
          const lng = markerOptions.longitude?Number(markerOptions.longitude):0
          const lat = markerOptions.latitude?Number(markerOptions.latitude):0
          const ste = markerOptions.ste
          const info = this.getGasValue(markerOptions.sb)
          if(lng&&lat){
            const marker = await this.addMarker({
              title: markerOptions.number,
              position: {lng,lat},
              map,
              info: markerOptions,
              icon: this.markerIcon(ste)
            });
            bounds.extend(marker.getPosition());
          }
        });
        // 调整地图视野以适应所有标记点
        this.googleMap.fitBounds(bounds);
      })
    },
    getGasValue(items) {
      let gas_data = this.$t("system.gas_data");
      let itemValue = "";
      for (let i in items) {
        if (items[i].sb_tye == 8) {
          itemValue +=
            items[i].name + "：" + gas_data[items[i].value] + "<br/>";
        } else {
          itemValue += items[i].name + "：" + items[i].value + "<br/>";
        }
      }
      return itemValue;
    },
    addMarker(options) {
      let controlIcon = require("../../assets/images/lamp-control.png")
      const { info, ...markerOptions } = options;
      const marker = new this.googleApi.maps.Marker(markerOptions);
      this.markers.push(marker);
      if (info) {
        const contentStr =
          `<div class="windowInfo">` +
            `<div class="title">${info.name}</div>` +
            `<div class="info_body">` +
              `<div class="item">${this.$t('device.device_number')}：<label>${info.number}</label></div>` +
              `<div class="item">${this.$t('device.device_model')}：<label>${info.device_type_name?info.device_type_name: '-'}</label></div>` +
              `<div class="item">${this.$t('device.single_Double')}：<label>${this.$t('device.lightStatus')[info.lights_status]}</label></div>` +
              `<div class="item">${this.$t('device.switch_state')}：<label class="open_ste${info.lights_status}">${this.$t('device.lightStatus')[info.lights_status]}</label></div>` +
              `<div class="item">${this.$t('device.current_strategy')}：<label>${info.stg_name}</label></div>` +
              `<div class="item">${this.$t('device.online_status')}：<label class="line_ste${info.ste}">${this.$t('device.steList')[info.ste]}</label></div>` +
              `<div class="item">${this.$t('device.group')}：<label>${info.group_name}</label></div>` +
              `<div class="item">${this.$t('device.current')}：<label>${info.current}</label></div>` +
              `<div class="item">${this.$t('device.voltage')}：<label>${info.voltage}</label></div>` +
            `</div>` +
            `<div class="info-controls">` +
              `<div class="botton-one" data-info='${JSON.stringify(info)}'>` +
                `<div class="icon"><img src="${controlIcon}"></div>` +
                `<div class="text">Lamp Control</div>` +
              `</div>` +
            `</div>` +
          `</div>`;
        const infoWindow = new this.googleApi.maps.InfoWindow({
          content: contentStr
        });
        let deviceOne= {
          name: info.name,
          number: info.number
        }
        this.searchDeviceList.push(deviceOne)
        this.infoWindowInstances.push(infoWindow); // 保存InfoWindow实例

        marker.addListener('click', () => {
          // 如果有当前打开的InfoWindow，则关闭它
          if (this.currentInfoWindow) {
            this.currentInfoWindow.close();
          }
          
          // 打开新的InfoWindow并设置为当前的InfoWindow
          infoWindow.open(this.googleMap, marker);
          this.currentInfoWindow = infoWindow;
          this.$nextTick(() => {
            // 为控制按钮添加点击事件
            const controlButton = document.querySelector('.botton-one[data-info]');
            if (controlButton) {
              controlButton.addEventListener('click', () => {
                const infoData = JSON.parse(controlButton.getAttribute('data-info'));
                this.showSet(infoData); // 调用 Vue 方法
              });
            }
          });
        });
      }
      this.markerInstances.push(marker); // 保存Marker实例
      return marker
    },
    markerIcon(ste) {
      return ste ? require("../../assets/images/darkblue_online.png") : require("../../assets/images/darkblue_line.png");
    },
    selectChange(params) {
      const { value, index } = params
      if (value) {
        //根据Id获取设备信息
        this.goToMarker(index)
      }
    },
    goToMarker(index) {
      if (index >= 0 && index < this.markerInstances.length) {
        const marker = this.markerInstances[index];
        const infoWindow = this.infoWindowInstances[index];

        // 将地图中心移动到指定标记的位置
        this.googleMap.panTo(marker.getPosition());

        // 如果有当前打开的InfoWindow，则关闭它
        if (this.currentInfoWindow) {
          this.currentInfoWindow.close();
        }

        // 打开指定标记的InfoWindow并设置为当前的InfoWindow
        infoWindow.open(this.googleMap, marker);
        this.currentInfoWindow = infoWindow;
      }
    },

    markerClick(marker) {
      this.center = [Number(marker.longitude), Number(marker.latitude)];
      this.zoom = 18;
      this.lampInfo = marker;
      this.currentWindow.position = [Number(marker.longitude), Number(marker.latitude)];
      this.currentWindow.visible = true;
    },
    showSet(setting) {
      console.log('showSet', setting)
      this.lightSetItem.title = setting.name
      this.lightSetItem.lightSetData = {
        lamp_id: setting.lamp_id,
        lamp_name: setting.name,
        is_double: parseInt(setting.is_double),
        light: setting.light,
        light2: setting.light2,
        stg_id: setting.stg_id,
        stg_name: setting.stg_name,
        ms: setting.ms
      }
      this.lightSetItem.visible = true
    },
    closeSet() {
      this.lightSetItem.visible = false
      this.lightSetItem.title = ''
      this.lightSetItem.lightSetData = {}
      this.getLampList()
    }
  }
}
</script>

<style lang='less'>
@color-primary:#0c82fe;
.gmap-container {
  width:100%;
  height:100%;
  position: relative;
  .lamp-search {
    position: absolute;
    top: 40px;
    right: 80px;
    z-index: 999;
    width:350px;
    .search-text{
      width:300px;
      overflow: hidden;
      padding:10px;
      box-sizing: border-box;
      .search-select{
        opacity: 0;
        height:50px;
        transform: translateX(100%);
        transition: all 0.5s;
        display: block;
        .el-input__inner {
          min-width:100px;
          height:50px;
          border-radius: 50px;
          font-size: 16px;
          padding-left: 20px;
          border: none;
          box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);
          &::placeholder,&::-webkit-input-placeholder {
            color: #333;
          }
          &:hover,&:focus {
            border-color: transparent;
          }
        }

        .el-icon-caret-top {
          display: none !important;
        }
      }
      &.search-show{
        .search-select{
          opacity: 1;
          transform: translateX(0);
          transition: all 0.5s;
        }
      }
    }
    .search-btn{
      position: absolute;
      right:0;
      top:7px;
      z-index: 22;
      background-color: @color-primary;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      width:50px;
      height:50px;
      font-size: 28px;
      border-radius: 50%;
      cursor: pointer;
      box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);
    }
  }

  .googleMap{
    width:100%;
    height:100%;
    position: relative;
  }

  .windowInfo{
    padding:0 10px;
    .title{
      font-weight: bold;
      font-size: 18px;
      color:#111;
    }
    .info_body{
      padding: 10px 0;
      .item{
        padding-bottom: 10px;
        font-size: 16px;
        color:#333;
        label{
          color:#111;
          font-weight: bold;
          &.open_ste0{
            color:#777;
          }
          &.open_ste1{
            color:#febf2a;
          }
          &.line_ste0{
            color:#777;
          }
          &.line_ste1{
            color:rgba(26, 151, 14, 0.856)
          }
        }
      }
    }

    .info-controls {
      padding:5px 10px 10px;
      display: flex;
      align-items: center;
      .botton-one{
        margin-right: 20px;
        cursor: pointer;
        outline: none;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .icon{
          border: 1px solid rgba(51, 153, 204, 0.5);
          border-radius: 50%;
          width: 50px;
          height: 50px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #e9e9ed;
          img{
            width: 30px;
            height: auto;
          }
        }
        .text{
          padding: 5px 0;
          font-size: 14px;
          text-align: center;
          color:#222;
        }
        &:hover{
          .icon{
            color:#000;
            background-color: #e9e9ed;
          }
          .text{
            color:#000;
          }
        }
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }

}
</style>
